export const mainBook = {
    title: "Journal des recettes"
}